import React from "react";
import { useNavigate } from "react-router-dom";

const UniPayment = () => {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/my_transaction?filter=All&paymentType=Unipayment");
  };

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4">
          How to Withdraw via Card (Refund)
        </h3>
        <ol className="list-decimal list-inside space-y-3 text-gray-700">
          <li>
            <strong>Navigate:</strong> Go to "My Transactions" via the sidebar in your dashboard or by clicking "Continue" below.
          </li>
          <li>
            <strong>Select:</strong> Locate the original deposit and click the Refund icon in the action column.
          </li>
          <li>
            <strong>Enter Amount:</strong> Input your withdrawal amount (Note: This cannot exceed the original deposit value).
          </li>
          <li>
            <strong>Submit:</strong> Confirm your details and click "Submit Request."
          </li>
          <li>
            <strong>Approval:</strong> Our team will review and process your request shortly.
          </li>
        </ol>
      </div>
      <button
        type="button"
        onClick={handleContinue}
        className="bg-primary text-white font-medium px-6 py-2.5 rounded-lg themeHover duration-500"
      >
        Continue
      </button>
    </div>
  );
};

export default UniPayment;
